import { render, staticRenderFns } from "./SortBySelector.vue?vue&type=template&id=30c5cfb9"
import script from "./SortBySelector.vue?vue&type=script&lang=js"
export * from "./SortBySelector.vue?vue&type=script&lang=js"
import style0 from "./SortBySelector.vue?vue&type=style&index=0&id=30c5cfb9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports